import React from "react"

import {H3, Body} from "@irati/ui/src/Typography"
import Button from "@irati/ui/src/Button"
import {FormattedMessage} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"

interface Props {
  onHide: () => void
  onConfirm: () => void
}

const CancelConfirm = (props: Props) => {
  return (
    <Flex direction="column">
      <H3>
        <FormattedMessage id="platform.popup.cancelConfirm.header" />
      </H3>
      <Body small marginBottom={1}>
        <FormattedMessage id="platform.popup.cancelConfirm.message" />
      </Body>
      <Flex alignItems="center" justifyContent="flex-end" gap={2}>
        <Button tertiary onClick={props.onHide}>
          <FormattedMessage id="platform.button.cancel" />
        </Button>
        <Button primary onClick={props.onConfirm}>
          <FormattedMessage id="platform.button.quit" />
        </Button>
      </Flex>
    </Flex>
  )
}

export default CancelConfirm
